"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CheckoutReducer_1 = require("../../checkout/reducers/CheckoutReducer");
const CheckoutSagas_1 = tslib_1.__importDefault(require("../../checkout/sagas/CheckoutSagas"));
const loadCheckoutModule = () => ({
    id: 'Checkout',
    reducerMap: {
        checkout: CheckoutReducer_1.checkoutReducer,
    },
    sagas: [CheckoutSagas_1.default],
});
exports.default = loadCheckoutModule;
